import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Card, CardContent } from '../ui/card'
import { UsersIcon } from 'lucide-react'

const SuperadminMatchingCounts = () => {
  const [counts, setCounts] = useState({ total: 0, active: 0 })

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/superadmin/matching-counts`, {
          withCredentials: true,
        })
        setCounts(res.data)
      } catch (err) {
        console.error('Fehler beim Laden der Matching-Zahlen', err)
      }
    }

    fetchCounts()
  }, [])

  return (
    <Card className="bg-slate-900 text-white rounded-2xl shadow-md p-4 w-full max-w-md">
      <CardContent className="flex flex-col">
        <div className="flex items-center gap-3">
          <UsersIcon className="w-6 h-6" />
          <div className="text-sm font-light text-slate-300">Matchings gesamt / aktiv</div>
        </div>
        <div className="mt-2 text-xl font-bold">
          {counts.active} / {counts.total}
        </div>
      </CardContent>
    </Card>
  )
}

export default SuperadminMatchingCounts
